import GooglePay from '~/assets/icons/payments-icons/google-pay.png';
import MasterCard from '~/assets/icons/payments-icons/mastercard.png';
import PayPal from '~/assets/icons/payments-icons/paypal.png';
import Visa from '~/assets/icons/payments-icons/visa.png';

export default function PaymentsImages() {
  return [
    <img key={'Visa'} style={{ marginRight: 16 }} src={Visa} />,
    <img key={'MasterCard'} style={{ marginRight: 16 }} src={MasterCard} />,
    <img key={'GooglePay'} style={{ marginRight: 16 }} src={GooglePay} />,
    <img key={'PayPal'} src={PayPal} />,
  ];
}
